const isInteger = (obj) => {
  return Math.floor(obj) === obj // 向下取整就是为了让整数部分截取下来不变
}

const toInteger = (floatNum) => {
  var ret = {
    times: 1,
    num: 0
  }
  if (isInteger(floatNum)) {
    ret.num = floatNum
    return ret
  }
  // 1.//转字符串
  var strfi = floatNum + ''
  // 2.//拿到小数点为
  var dotPos = strfi.indexOf('.')
  // 3. //截取需要的长度
  var len = strfi.substr(dotPos + 1).length
  // 4.倍数就是长度的幂
  var times = Math.pow(10, len)
  var intNum = parseInt(floatNum * times, 10)
  ret.times = times
  ret.num = intNum
  return ret
}

export default (a, b, op) => { // add/subtract/multiply/divide
  var o1 = toInteger(a)
  var o2 = toInteger(b)
  var n1 = o1.num
  var n2 = o2.num
  var t1 = o1.times
  var t2 = o2.times
  var max = t1 > t2 ? t1 : t2
  var result = null
  switch (op) {
    case 'add':
      if (t1 === t2) { // 两个小数位数相同
        result = n1 + n2
      } else if (t1 > t2) { // o1 小数位 大于 o2
        result = n1 + n2 * (t1 / t2)
      } else { // o1 小数位 小于 o2
        result = n1 * (t2 / t1) + n2
      }
      return result / max
    case 'subtract':
      if (t1 === t2) {
        result = n1 - n2
      } else if (t1 > t2) {
        result = n1 - n2 * (t1 / t2)
      } else {
        result = n1 * (t2 / t1) - n2
      }
      return result / max
    case 'multiply':
      result = (n1 * n2) / (t1 * t2)
      return result
    case 'divide':
      result = (n1 / n2) * (t2 / t1)
      return result
  }
}
